import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthenticationService } from "../shared/services/authService";
import { environment } from "../../environments/environment";
@Injectable()
export class APIService {
  // EndPoints:
  public _config = environment;
  private getlogData = "api/get_status/";
  // private PasswordSetRequest = "api/password_set_request/";
  // private ValidateToken = "api/password_set_validated/";
  // private searchLog = "api/access_downloader/";
  private uploadFile = "api/create_job/";
  // private getPasswordHist = "api/get_last_changed_on/";
  errorMessage: BehaviorSubject<any> = new BehaviorSubject([]);
  errorOfValToken: BehaviorSubject<string> = new BehaviorSubject("");
  dataError: BehaviorSubject<boolean> = new BehaviorSubject(false);
  disableButton: BehaviorSubject<boolean> = new BehaviorSubject(false);
  fileErrors: BehaviorSubject<any> = new BehaviorSubject([]);
  textOfFile: any;
  public serverURL = this._config.serverIP;
  constructor(
    private _authService: AuthenticationService,
    private http: HttpClient
  ) {}

  getAllLogData(): Observable<any> {
    return new Observable((observer) => {
      let keys = this.getKeys();
      if (keys) {
        this._authService
          .HMACGeneration(keys.userKey, keys.secretKey, {
            endPoint: "/" + this.getlogData,
            method: "POST",
          })
          .subscribe((res) => {
            let headerOptions = {
              HMAC_Sign: res.HMAC_Sign,
              user_key: res.user_key,
              timeStamp: res.timeStamp,
            };
            // console.log(headerOptions);

            this.http
              .post(
                this.serverURL + this.getlogData,
                {},
                this.setHeaders(headerOptions)
              )
              .subscribe(
                (data) => {
                  let response: any = data;
                  observer.next({ status: "ok", result: response });
                  observer.complete();
                },
                // (err) => {
                //   observer.next({ status: "error", result: [] });
                //   observer.complete();
                // }
                (err) => {
                  observer.error(err);
                }
              );
          });
      } else {
        this.dataError.next(true);
      }
    });
  }

  readFileData(file): Observable<any> {
    return new Observable((observer) => {
      if (file) {
        let fileReader = new FileReader();
        fileReader.readAsText(file, "utf-8");

        fileReader.addEventListener("load", (event: any) => {
          this.textOfFile = fileReader.result;
          if (this.textOfFile.split("\n").length <= 1000002) {
            let obj = {
              data: this.textOfFile,
              name: file.name,
            };
            observer.next({ status: "ok", fileObj: obj });
            observer.complete();
          } else {
            this.fileErrors
              .getValue()
              .push("File size cannot exceeds more than 5 MB!");
            this.fileErrors.next(this.fileErrors.getValue());
          }
        });
      }
    });
  }

  getKeys() {
    if (
      sessionStorage.getItem("userKey") &&
      sessionStorage.getItem("secretKey")
    ) {
      return {
        userKey: sessionStorage.getItem("userKey"),
        secretKey: sessionStorage.getItem("secretKey"),
      };
    } else {
      return;
    }
  }

  setHeaders(hmacData) {
    let options;
    let user = this.getFromLocal("currentUser_EPC_Portfolio");
    if (!!user) {
      let token = JSON.parse(user);
      const headers = new HttpHeaders({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "jwt " + token,
        Signature: hmacData.HMAC_Sign,
        Key: hmacData.user_key,
        timestamp: hmacData.timeStamp,
        Pragma: "no-cache",
        "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
        "X-XSS-Protection": "1",
        "X-Content-Type-Options": "nosniff",
        "X-Frame-Options": token,
      });
      options = {
        headers: headers,
      };
    }
    return options;
  }

  setFileHeader(hmacData) {
    let options;
    let user = this.getFromLocal("currentUser_EPC_Portfolio");
    if (!!user) {
      let token = JSON.parse(user);
      const headers = new HttpHeaders({
        Authorization: "jwt " + token,
        Signature: hmacData.HMAC_Sign,
        Key: hmacData.user_key,
        timestamp: hmacData.timeStamp,
        Pragma: "no-cache",
        "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
      });
      options = {
        headers: headers,
      };
    }
    //   console.log(options);

    return options;
  }

  getFromLocal(item) {
    return sessionStorage.getItem(item);
  }

  uploadTSV(fileData, file, param): Observable<any> {
    return new Observable((observer) => {
      let keys = this.getKeys();
      if (keys) {
        let formData: FormData = new FormData();
        formData.append("result_count", param.result_count.toString());
        formData.append("score", param.score.toString());
        formData.append("is_exact", param.is_exact.toString());
        formData.append("upload_file_name", file);

        this._authService
          .HMACGeneration(keys.userKey, keys.secretKey, {
            endPoint: "/" + this.uploadFile,
            method: "POST",
            parameters: {
              result_count: param.result_count.toString(),
              score: param.score.toString(),
              is_exact: param.is_exact.toString(),
              upload_file_name: fileData,
            },
          })
          .subscribe((res) => {
            let headerOptions = {
              HMAC_Sign: res.HMAC_Sign,
              user_key: res.user_key,
              timeStamp: res.timeStamp,
            };
            this.http
              .post(
                this.serverURL + this.uploadFile,
                formData,
                this.setFileHeader(headerOptions)
              )
              .subscribe(
                (response) => {
                  observer.next({ status: "ok", result: response });
                  observer.complete();
                },
                (err) => {
                  if (err.error) {
                    if (
                      err.error.error &&
                      (err.error.error.includes("Unicode Decode Error") ||
                        err.error.error.includes("UnicodeDecodeError"))
                    ) {
                      if (
                        this.fileErrors
                          .getValue()
                          .indexOf(
                            "Invalid Encoding of the file, it should be 'UTF-8'"
                          ) == -1
                      ) {
                        this.fileErrors
                          .getValue()
                          .push(
                            "Invalid Encoding of the file, it should be 'UTF-8'"
                          );
                      }
                    }
                    if (
                      this.fileErrors
                        .getValue()
                        .indexOf("Uploading failed, Please try again!") == -1
                    ) {
                      this.fileErrors
                        .getValue()
                        .push("Uploading failed, Please try again!");
                    }
                    this.fileErrors.next(this.fileErrors.getValue());
                  }
                  observer.next({ status: "error" });
                  observer.complete();
                }
              );
          });
      } else {
        this.dataError.next(true);
      }
    });
  }

  // searchLogData(str): Observable<any> {
  //   return new Observable((observer) => {
  //     let keys = this.getKeys();
  //     if (keys) {
  //       this._authService
  //         .HMACGeneration(keys.userKey, keys.secretKey, {
  //           endPoint: "/" + this.searchLog,
  //           method: "POST",
  //           parameters: {
  //             uu_id: str,
  //           },
  //         })
  //         .subscribe((res) => {
  //           let headerOptions = {
  //             HMAC_Sign: res.HMAC_Sign,
  //             user_key: res.user_key,
  //             timeStamp: res.timeStamp,
  //           };
  //           this.http
  //             .post(
  //               this.serverURL + this.searchLog,
  //               {
  //                 uu_id: str,
  //               },
  //               this.setHeaders(headerOptions)
  //             )
  //             .subscribe(
  //               (response) => {
  //                 observer.next({ status: "ok", result: response });
  //                 observer.complete();
  //               },
  //               (err) => {
  //                 if (err.error) {
  //                   observer.next({ status: "error" });
  //                   observer.complete();
  //                 }
  //               }
  //             );
  //         });
  //     } else {
  //       this.dataError.next(true);
  //     }
  //   });
  // }

  // GetPassHist(): Observable<any> {
  //   return new Observable((observer) => {
  //     let keys = this.getKeys();
  //     if (keys) {
  //       this._authService
  //         .HMACGeneration(keys.userKey, keys.secretKey, {
  //           endPoint: "/" + this.getPasswordHist,
  //           method: "GET",
  //         })
  //         .subscribe((res) => {
  //           let headerOptions = {
  //             HMAC_Sign: res.HMAC_Sign,
  //             user_key: res.user_key,
  //             timeStamp: res.timeStamp,
  //           };
  //           this.http
  //             .get(
  //               this.serverURL + this.getPasswordHist,
  //               this.setHeaders(headerOptions)
  //             )
  //             .subscribe(
  //               (response) => {
  //                 observer.next({
  //                   status: "ok",
  //                   result: (response as any).reset_request_on.toString(),
  //                 });
  //                 observer.complete();
  //               },
  //               (err) => {
  //                 if (err.error) {
  //                   this.errorMessage
  //                     .getValue()
  //                     .push("Something went wrong, Please try again later!");
  //                   this.errorMessage.next(this.errorMessage.getValue());
  //                   observer.next({ status: "error" });
  //                   observer.complete();
  //                 }
  //               }
  //             );
  //         });
  //     } else {
  //       this.dataError.next(true);
  //     }
  //   });
  // }

  // sendPassword(password): Observable<any> {
  //   return new Observable((observer) => {
  //     let keys = this.getKeys();
  //     if (keys) {
  //       this._authService
  //         .HMACGeneration(keys.userKey, keys.secretKey, {
  //           endPoint: "/" + this.PasswordSetRequest,
  //           method: "POST",
  //           parameters: {
  //             password: password,
  //           },
  //         })
  //         .subscribe((res) => {
  //           let headerOptions = {
  //             HMAC_Sign: res.HMAC_Sign,
  //             user_key: res.user_key,
  //             timeStamp: res.timeStamp,
  //           };
  //           this.http
  //             .post(
  //               this.serverURL + this.PasswordSetRequest,
  //               {
  //                 password: password,
  //               },
  //               this.setHeaders(headerOptions)
  //             )
  //             .subscribe(
  //               (response) => {
  //                 observer.next({ status: "ok", result: response });
  //                 observer.complete();
  //               },
  //               (err) => {
  //                 if (err.error) {
  //                   this.errorMessage
  //                     .getValue()
  //                     .push("Something went wrong, Please try again later!");
  //                   this.errorMessage.next(this.errorMessage.getValue());
  //                   observer.next({ status: "error" });
  //                   observer.complete();
  //                 }
  //               }
  //             );
  //         });
  //     } else {
  //       this.dataError.next(true);
  //     }
  //   });
  // }

  // validateToken(token) {
  //   return new Observable((observer) => {
  //     let keys = this.getKeys();
  //     if (keys) {
  //       this._authService
  //         .HMACGeneration(keys.userKey, keys.secretKey, {
  //           endPoint: "/" + this.ValidateToken,
  //           method: "POST",
  //           parameters: {
  //             password_reset_token: token,
  //           },
  //         })
  //         .subscribe((res) => {
  //           let headerOptions = {
  //             HMAC_Sign: res.HMAC_Sign,
  //             user_key: res.user_key,
  //             timeStamp: res.timeStamp,
  //           };
  //           this.http
  //             .post(
  //               this.serverURL + this.ValidateToken,
  //               {
  //                 password_reset_token: token,
  //               },
  //               this.setHeaders(headerOptions)
  //             )
  //             .subscribe(
  //               (data) => {
  //                 let response: any = data;
  //                 if (response.error_code == "1") {
  //                   this.disableButton.next(false);
  //                   this.errorOfValToken.next("");
  //                   observer.next({ status: "ok", result: response });
  //                   observer.complete();
  //                 } else {
  //                   this.errorOfValToken.next("Incorrect token");
  //                   this.disableButton.next(true);
  //                   observer.next({ status: "error", result: response.data });
  //                   observer.complete();
  //                 }
  //               },
  //               (err) => {
  //                 if (err.error) {
  //                   this.errorOfValToken.next(
  //                     "Something went wrong, Please try again later!"
  //                   );
  //                   this.disableButton.next(true);

  //                   observer.next({ status: "error" });
  //                   observer.complete();
  //                 }
  //               }
  //               // OJ1KJ
  //             );
  //         });
  //     } else {
  //       this.dataError.next(true);
  //     }
  //   });
  // }

  // PushErrorMessages(msg) {
  //   this.errorMessage.getValue().push(msg);
  //   this.errorMessage.next(this.errorMessage.getValue());
  // }
}
